<template>
    <AppLayout />
</template>

<script lang="ts">
    import { defineComponent } from 'vue'

    import AppLayout from '@/layouts/components/AppLayout.vue'
    export default defineComponent({
        name: 'Default',
        components: {
            AppLayout
        }
    })
</script>
